<template>
  <div  class="table-body__content" :ref="isOutsideTbody ? 'tbody' : 'tbody-inside'">
    <ul class="table-body">
      <slot></slot>
    </ul>
  </div>

</template>

<script>
// import IScroll from 'iscroll'
export default {
  name: 'v-tbody',
  props: {
    isOutsideTbody: {
      type: Boolean,
      default: false
    }
  // },
  // mounted () {
  //   this.$nextTick(() => {
  //     this.initScroll()
  //   })
  // },
  // updated () {
  //   this.initScroll()
  // },
  // computed: {
  //   currentTbody () {
  //     return this.$refs.tbody
  //   }
  // },
  // methods: {
  //   initScroll () {
  //     // if (this.menuScroll) {
  //     //   this.menuScroll.destroy()
  //     //   this.menuScroll = null
  //     // }
  //     if (this.$refs.tbody) {
  //       console.info('this.currentTbody:', this.currentTbody)
  //       console.info('this.$refs.tbody_height:', this.currentTbody.clientHeight)
  //       this.menuScroll = new IScroll(this.$refs.tbody, {
  //         scrollbars: true,
  //         mouseWheel: true,
  //         interactiveScrollbars: true,
  //         shrinkScrollbars: 'scale',
  //         fadeScrollbars: false
  //       })
  //     }
  //   }
  }
}
</script>

<style scoped lang="sass">
.table-body__content
  position: relative
  // overflow: hidden
  clear: both
  border-top: 1px solid #ddd
.table-body
  clear: both
  border-bottom: 1px solid #ddd
  .table-body
    border-bottom: none

</style>



// WEBPACK FOOTER //
// VTbody.vue?48ffa4b6